export class ApiError extends Error {
  constructor(body: any) {
    super(JSON.stringify(body, null, 2));
  }
}
